(function () {
  if (window.__jvFreeShippingBarInited) return;
  window.__jvFreeShippingBarInited = true;

  var THRESHOLD = 19900;      // livrare gratuita + primul cadou (199 RON)
  var T2 = 50000;             // al 2-lea semn cadou (500 RON)
  var T3 = 80000;             // al 3-lea semn cadou (800 RON) — maxim
  var GIFT = 58379730747656;  // semn de carte piele AB-27A
  var busy = false;

  function formatRon(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' RON';
  }

  function targetGiftQty(qualifying) {
    if (qualifying >= T3) return 3;
    if (qualifying >= T2) return 2;
    if (qualifying >= THRESHOLD) return 1;
    return 0;
  }

  function refresh() {
    // NU iesim devreme daca bara nu e in DOM — controlul cantitatii cadoului trebuie sa ruleze oricum.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Prag calculat NOI din produsele non-cadou (nu ne bazam pe discountul recalculat de Shopify).
        var qualifying = 0;
        var giftItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.variant_id === GIFT) { giftItem = it; }
          else { qualifying += it.final_line_price; }
        }

        var target = targetGiftQty(qualifying);
        var current = giftItem ? giftItem.quantity : 0;

        // AUTO-ADD cadou: se adauga SINGUR cand cosul trece pragul (1 la 199, 2 la 500, 3 la 800),
        // scaleaza automat intre trepte, si se scoate singur daca scazi sub prag. (Inainte era opt-in
        // pe buton -> ~38% din comenzile >199 ratau cadoul. Acum il primesc toti calificatii.)
        if (!busy && current !== target) {
          busy = true;
          var done = function () {
            busy = false;
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'jv-fsb-gift' } }));
            refresh();
          };
          var fail = function () { busy = false; };
          if (!giftItem && target > 0) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: GIFT, quantity: target }] })
            }).then(done).catch(fail);
          } else if (giftItem) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftItem.key, quantity: target })
            }).then(done).catch(fail);
          } else {
            busy = false;
          }
          return;
        }

        var bars = document.querySelectorAll('[data-jv-free-shipping-bar]');
        if (!bars.length) return;
        var giftInCart = !!giftItem;
        var remaining = Math.max(0, THRESHOLD - qualifying);
        var pct = qualifying >= THRESHOLD ? 100 : Math.min(100, (qualifying / THRESHOLD) * 100);

        bars.forEach(function (bar) {
          if (cart.item_count === 0) { bar.setAttribute('hidden', ''); return; }
          bar.removeAttribute('hidden');

          var fill = bar.querySelector('[data-jv-fsb-fill]');
          var msg = bar.querySelector('[data-jv-fsb-message]');
          if (fill) fill.style.width = pct + '%';
          if (msg) {
            if (qualifying >= T3) {
              msg.innerHTML = '🎉 <strong>Ai livrare GRATUITĂ + 3 semne de carte cadou!</strong>';
            } else if (qualifying >= T2) {
              msg.innerHTML = 'Ai <strong>2 semne de carte cadou</strong>! Mai adaugă <strong>' +
                formatRon(T3 - qualifying) + '</strong> pentru al 3-lea 🎁';
            } else if (qualifying >= THRESHOLD) {
              msg.innerHTML = '🎉 <strong>Livrare GRATUITĂ + 1 semn cadou!</strong> Mai adaugă <strong>' +
                formatRon(T2 - qualifying) + '</strong> pentru al 2-lea 🎁';
            } else {
              msg.innerHTML = 'Mai adaugă <strong data-jv-fsb-remaining>' + formatRon(remaining) +
                '</strong> pentru <strong>LIVRARE GRATUITĂ + CADOU</strong>! 🚚🎁';
            }
          }

          var giftBox = bar.querySelector('[data-jv-fsb-gift]');
          var giftAdd = bar.querySelector('[data-jv-fsb-gift-add]');
          var giftDone = bar.querySelector('[data-jv-fsb-gift-done]');
          if (giftBox) { if (qualifying >= THRESHOLD) giftBox.removeAttribute('hidden'); else giftBox.setAttribute('hidden', ''); }
          if (giftAdd) { if (giftInCart) giftAdd.setAttribute('hidden', ''); else giftAdd.removeAttribute('hidden'); }
          if (giftDone) { if (giftInCart) giftDone.removeAttribute('hidden'); else giftDone.setAttribute('hidden', ''); }
        });
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.source === 'jv-fsb-gift') return;
    setTimeout(refresh, 60);
  });
  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();

  function startObserver() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.tagName === 'DIALOG' && t.open) { refresh(); break; }
      }
    });
    observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
  if (document.body) startObserver(); else document.addEventListener('DOMContentLoaded', startObserver);
})();
